import { canAssignStaff, hasPermission } from "./commonutils";

export const PAYMENT_RECOVERY_INQUIRY_TYPES = ["payment_recovery"];
export const GST_INQUIRY_TYPES = ["gst", "case_management"];

export const pipelineForInquiryType = (type) => {
  if (PAYMENT_RECOVERY_INQUIRY_TYPES.includes(type)) return "payment_recovery";
  if (GST_INQUIRY_TYPES.includes(type)) return "gst";
  return "customer";
};

export const canUsePaymentRecoveryFlow = (role) =>
  canAssignStaff(role) || hasPermission("create_paymentrecovery") || hasPermission("read_paymentrecovery");

export const canUseGstFlow = (role) =>
  canAssignStaff(role) || hasPermission("create_casemanagement") || hasPermission("read_casemanagement");

export const canConvertPaymentRecovery = (role) =>
  canAssignStaff(role) || hasPermission("create_paymentrecovery");

export const canConvertGst = (role) =>
  canAssignStaff(role) || hasPermission("create_casemanagement");

export const canConvertCustomer = (role) =>
  canAssignStaff(role) || hasPermission("create_customer");

export const getAllowedInquiryTypes = (role) => {
  if (canAssignStaff(role)) return null;
  const types = ["general", "task"];
  if (canUsePaymentRecoveryFlow(role)) types.push("payment_recovery");
  if (canUseGstFlow(role)) types.push("gst", "case_management");
  return types;
};

export const defaultInquiryType = (role) => {
  const allowed = getAllowedInquiryTypes(role);
  if (!allowed) return "general";
  const hasPr = allowed.includes("payment_recovery");
  const hasGst = allowed.includes("gst") || allowed.includes("case_management");
  if (hasPr && !hasGst) return "payment_recovery";
  if (hasGst && !hasPr) return "gst";
  return "general";
};

export const getInquiryWorkstreamPills = (role) => {
  const allowed = getAllowedInquiryTypes(role);
  const pills = [{ key: "all", label: "All", types: allowed }];
  if (!allowed || allowed.includes("payment_recovery")) {
    pills.push({ key: "payment_recovery", label: "Payment recovery", types: ["payment_recovery"] });
  }
  if (!allowed || allowed.includes("gst") || allowed.includes("case_management")) {
    pills.push({ key: "gst", label: "GST", types: ["gst", "case_management"] });
  }
  if (!allowed || allowed.includes("general")) {
    pills.push({ key: "general", label: "General", types: ["general"] });
  }
  if (!allowed || allowed.includes("task")) {
    pills.push({ key: "task", label: "Task", types: ["task"] });
  }
  return pills;
};

export const canConvertInquiry = (inquiry, role) => {
  if (!inquiry || inquiry.convertedTo || inquiry.status === "converted") return false;
  const pipeline = pipelineForInquiryType(inquiry.type);
  if (pipeline === "payment_recovery") return canConvertPaymentRecovery(role);
  if (pipeline === "gst") return canConvertGst(role);
  return canConvertCustomer(role);
};
